import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

const SAFEFields = ({ formData, onFieldChange, config }) => {
  return (
    <>
      <div className="space-y-2">
        <Label htmlFor="valuation_cap" className="portfolio-input-label">Valuation Cap</Label>
        <Input
          id="valuation_cap"
          data-testid="valuation-cap-safe-input"
          type="number"
          placeholder="e.g. 10000000"
          value={formData.valuation_cap}
          onChange={(e) => onFieldChange('valuation_cap', e.target.value)}
          className="portfolio-input"
        />
      </div>
      
      {config?.valuation_cap_types && (
        <div className="space-y-2">
          <Label htmlFor="valuation_cap_type" className="portfolio-input-label">Valuation Cap Type</Label>
          <Select value={formData.valuation_cap_type} onValueChange={(value) => onFieldChange('valuation_cap_type', value)}>
            <SelectTrigger data-testid="valuation-cap-type-select" className="portfolio-input">
              <SelectValue placeholder="Select cap type" />
            </SelectTrigger>
            <SelectContent>
              {config.valuation_cap_types.map(capType => (
                <SelectItem key={capType.value} value={capType.value}>{capType.label}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      )}
      
      <div className="space-y-2">
        <Label htmlFor="discount_rate" className="portfolio-input-label">Discount Rate (%)</Label>
        <Input
          id="discount_rate"
          data-testid="discount-rate-safe-input"
          type="number"
          step="0.01"
          placeholder="e.g. 20"
          value={formData.discount_rate}
          onChange={(e) => onFieldChange('discount_rate', e.target.value)}
          className="portfolio-input"
        />
      </div>
    </>
  );
};

export default SAFEFields;
